/* VICETA WANG — Mobile collection image swiping */
(() => {
  let gesture = null;
  let suppressClick = false;

  document.addEventListener("touchstart", (event) => {
    if (!window.matchMedia("(max-width: 699px)").matches) return;

    const gallery = event.target.closest(".mobile-swipe-gallery");
    if (!gallery) return;

    const images = gallery.querySelectorAll(".product-card__image");
    if (images.length < 2) return;

    gesture = {
      gallery,
      x: event.touches[0].clientX,
      y: event.touches[0].clientY
    };
  }, { passive: true });

  document.addEventListener("touchend", (event) => {
    if (!gesture) return;

    const { gallery, x, y } = gesture;
    gesture = null;

    const dx = event.changedTouches[0].clientX - x;
    const dy = event.changedTouches[0].clientY - y;

    if (Math.abs(dx) < 35 || Math.abs(dx) <= Math.abs(dy)) return;

    const primary = gallery.querySelector(".product-card__image--primary");
    const secondary = gallery.querySelector(".product-card__image--secondary");

    if (!primary || !secondary) return;

    const showSecondary = dx < 0;
    if (showSecondary) {
  secondary.style.setProperty("display", "block", "important");
  secondary.style.setProperty("opacity", "1", "important");
  secondary.style.setProperty("visibility", "visible", "important");
  secondary.style.setProperty("z-index", "10", "important");
}

primary.style.setProperty("display", "block", "important");
secondary.style.setProperty("display", "block", "important");

    primary.style.setProperty(
      "visibility", showSecondary ? "hidden" : "visible", "important"
    );

    secondary.style.setProperty(
      "visibility", showSecondary ? "visible" : "hidden", "important"
    );

    primary.style.setProperty(
      "opacity", showSecondary ? "0" : "1", "important"
    );

    secondary.style.setProperty(
      "opacity", showSecondary ? "1" : "0", "important"
    );

    suppressClick = true;
  }, { passive: true });

  document.addEventListener("touchcancel", () => {
    gesture = null;
  });

  document.addEventListener("click", (event) => {
    if (!suppressClick) return;
    if (!event.target.closest(".mobile-swipe-gallery")) return;

    event.preventDefault();
    event.stopPropagation();
    suppressClick = false;
  }, true);
})();
